export default __webpack_public_path__ + "static/media/CM_COLOR.a05a4da8.jpg";